module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Light.7894314.woff2";